import { Component, Input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RegionId } from '../../core/model/region-id.enum';
import { RegionNamePipe } from '../../core/pipe/region-name.pipe';
import { RegionImagePipe } from '../../core/pipe/region-image.pipe';

@Component({
    selector: 'app-region-name',
    standalone: true,
    imports: [CommonModule, RegionNamePipe, RegionImagePipe, NgOptimizedImage],
    template: `
        <ng-container *ngIf="regionId != null">
            <div class="d-inline-flex align-items-center justify-content-center gap-1">
                <span *ngIf="regionId | regionImage | async as regionImage">
                    <img [ngSrc]="regionImage" width="16" height="16" alt="region-image" />
                </span>
                <span>{{ regionId | regionName | async }}</span>
            </div>
        </ng-container>
    `,
    styleUrls: ['./region-name.component.scss'],
    host: {
        class: 'text-nowrap',
    },
})
export class RegionNameComponent {
    @Input() regionId?: RegionId | null;
}
